import {
  FETCH_SYMSTYLE_DATA,
  FETCH_SYMSTYLE_DATA_ERROR,
  FETCH_SYMSTYLE_DATA_LOADING
} from "../constants";
import client from "../apolloClient";
import gql from "graphql-tag";

export function symstyleDataFetchData(fetchQuery) {
  return dispatch => {
    dispatch(symstyleDataIsLoading(true));
    let query;

    if (fetchQuery) {
      query = fetchQuery;
    } else {
      query = gql`
        {
          arasaac_caa_t_symstyle {
            id
            paramstyle
          }
        }
      `;
    }

    client
      .query({ query })
      .then(data => {
        dispatch(symstyleDataIsLoading(false));
        
        if (data.networkStatus !== 7) {
          dispatch(symstyleDataHasErrored(true));
        } else {
          let imgStyle = [{ type: "imgstyle", value: 0, text: "random" }];
          let arrayData = data.data.arasaac_caa_t_symstyle;
          for (let i = 0; i < arrayData.length; i++) {
            imgStyle.splice(i + 1, 0, {
              type: "imgstyle",
              value: arrayData[i].id,
              text: arrayData[i].paramstyle
            });
          }
          dispatch(symstyleDataFetchDataSuccess(imgStyle));
          dispatch(symstyleDataHasErrored(false));
        }
      })
      .catch(error => {
        dispatch(symstyleDataIsLoading(false));
        dispatch(symstyleDataHasErrored(true));
      });
  };
}

export function symstyleDataHasErrored(bool) {
  return {
    type: FETCH_SYMSTYLE_DATA_ERROR,
    hasErrored: bool
  };
}

export function symstyleDataIsLoading(bool) {
  return {
    type: FETCH_SYMSTYLE_DATA_LOADING,
    isLoading: bool
  };
}

export function symstyleDataFetchDataSuccess(symstyleData) {
  return {
    type: FETCH_SYMSTYLE_DATA,
    symstyle: symstyleData
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/SymStyleFetchActions.js